import {ActionButton, DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../../app/shared/models/campo-aggiuntivo";
import {Permission} from "../../../../app/Login/_guards/Permission";
import {dateTimeStringToFormattedDate} from "../../../Utility/DateUtility";
import {DynamicListComponent} from "../../../../app/shared/dynamic-list/dynamic-list.component";
import {forkJoin} from "rxjs";
import {ApiPathsService} from "../../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {GetFromLocalStorage, SaveToLocalStorage} from "../../../Utility/Utility";
import {GetCarrello, GetCarrelloCount, PrezzoIvato} from "./../ProductUtility";
import {data} from "jquery";
import {getOrdineDefaultSave} from "./../Ordini_Ricevuti";
import {DynamicEditComponent} from "../../../../app/shared/dynamic-edit/dynamic-edit.component";
import {FieldViewerComponent} from "../../../../app/shared/field-viewer/field-viewer.component";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";

function config_prodotto() {

  const OBJ: OggettoConfig = {

    Id: "config_prodotto",
    RestRoute: '/settings/get',
    NoSave:true,
    Azioni: [

      ActionButton.FuncButton(
        "Salva configurazione",
        (
          x,
          api,
          onEnd
        ) => {

          if (
            x.selectedMainTab === 'stagioni'
          ) {

            SaveStagioni(
              x,
              api
            );

            return;
          }

        },
        {
          class: 'btn btn-success',
          hideif: {
            func: (x) =>
              x.selectedMainTab === 'stagioni'
          }
        }
      )

    ],
    EditView: "Page",
    listTitle: 'Config prodotto',
    asyncMap: (x, component, callback) => {
      x.component = component;
      component.api.ClassicPost(
        '/prodotti/categorie/list',
        {}
      ).subscribe((categorie: any[]) => {

        x.categorieTree = categorie || [];

        x.selectedMainTab = 'categorie';

        x.selectedMacro =
          categorie?.[0];

        x.selectedMiddle =
          categorie?.[0]?.figli?.[0];
        LoadMicroTaglie(
          x,
          () => {
            callback(x);
          }
        );

      });


    },

    campi: [

      CampoAggiuntivo.InputField(
        "",
        "campiMain",
        "",
        "col-12",
        {
          type: 'ArrayCampiAggiuntivi',



        }
      )

    ],


    MenuItems: [
      {
        path: 'shared/dynamicedit/config_prodotto',
        title: "Config prodotto",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
        notruoliOperativi: ['C']

      }
    ]

  };

  return OBJ;

}

function TopTabs() {

  const tabs = [
    {
      id: 'categorie',
      label: '📂 Categorie'
    },
    {
      id: 'colori',
      label: '🎨 Colori'
    },
    {
      id: 'stagioni',
      label: '☀️ Stagioni'
    },
    {
      id: 'brand',
      label: '🏆 Top Brand'
    }
  ];

  return tabs.map(tab => {

    return CampoAggiuntivo.Html(
      "",
      (x) => `

        <div class="
          cfg-main-tab
          ${x.selectedMainTab === tab.id ? 'active' : ''}
        ">

          ${tab.label}

        </div>

      `,
      () => true,
      {
        class: 'cfg-top-tab-wrapper',

        onClick: (obj) => {

          obj.selectedMainTab = tab.id;

          if (tab.id === 'colori') {

            ReloadColori(
              obj,
              obj.component.api
            );

            return;
          }
          if(tab.id === 'stagioni') {
            ReloadStagioni(
              obj,
              obj.component.api
            );

            return;
          }
          if(tab.id === 'brand') {
            ReloadBrand(
              obj,
              obj.component.api
            );
            return;
          }


          refreshLayout(obj);

        }

      }
    );

  });

}


function DescriptionField() {

  return [

    CampoAggiuntivo.Html(
      "",
      () => `

        <div class="cfg-description">

          Definisci la gerarchia Macro → Sotto → Micro categoria.
          Le taglie si impostano per ogni sotto categoria e vengono ereditate
          dalle micro se non personalizzate.

        </div>

      `,
      () => true,
      {
        class: 'col-12',
        hideif: {
          func: (x) => x.selectedMainTab === 'categorie'
        }
      }
    )

  ];

}
function MainLayout(x) {
  if (x.selectedMainTab === 'colori') {
    return LayoutColori(x);
  }
  if (x.selectedMainTab === 'brand') {
    return LayoutBrand(x);
  }
  if (x.selectedMainTab === 'stagioni') {
    return LayoutStagioni(x);
  }
  return LayoutCategorie(x);
}
function LayoutBrand(x){
  return[
    CampoAggiuntivo.Html(
      "",
      `
        <div class="cfg-brand-card">

          <div class="cfg-brand-title">
            🏆 Top 5 — Più venduti
          </div>

          <div class="cfg-brand-subtitle">
            Calcolati automaticamente in base al volume vendite. Non modificabili.
          </div>

          <div class="cfg-brand-list">

            ${(x.topBrandList || []).length
        ? (x.topBrandList || []).slice(0, 5).map((brand, index) => `

                <div class="cfg-brand-row">

                  <div class="cfg-brand-left">

                    <span class="cfg-brand-rank">
                      ${index + 1}
                    </span>

                    <span class="cfg-brand-name">
                      ${brand.label || brand.nome}
                    </span>

                  </div>

                  <div class="cfg-brand-value">
€${Number(brand.gmv || 0).toLocaleString('it-IT', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })} GMV
                  </div>

                </div>

              `).join('')
        : `
                <div class="cfg-brand-empty">
                  Nessun brand trovato
                </div>
              `
      }

          </div>

        </div>
      `,
      () => true,
      {
        class: 'col-12'
      }
    )
  ];
}
function LayoutStagioni(x) {

 /* x.stagioniTable = [...(x.stagioniList || [])]
    .sort((a, b) => (a.ordine || 0) - (b.ordine || 0))
    .map(stagione => ({
      ...stagione,
      nome: stagione.check || '',
      ordine: stagione.ordine || 0
    }));*/

  return [

    CampoAggiuntivo.Html(
      "",
      `
        <div class="cfg-stagioni-header">
          <div class="cfg-column-title big">
            ☀️ Stagioni
          </div>
        </div>
      `,
      () => true,
      { class: 'col-12' }
    ),

    CampoAggiuntivo.Html(
      "",
      `
        <div class="cfg-popup-info">
          ℹ️ Trascina le stagioni per modificarne l’ordine di visualizzazione.
        </div>
      `,
      () => true,
      { class: "col-12" }
    ),

    CampoAggiuntivo.DraggableTableField(
      "Stagioni",
      [
        CampoAggiuntivo.TextField(
          "Nome",
          "nome",
          "col-lg-12",
          {
            placeholder: "Nome stagione"
          }
        )
      ],
      "stagioniTable",
      true,
      "col-12",
      (event: CdkDragDrop<string[]>, component, lista) => {

        moveItemInArray(
          lista,
          event.previousIndex,
          event.currentIndex
        );

        lista.forEach((stagione, index) => {
          stagione.ordine = index + 1;
        });

      }
    ),

    CampoAggiuntivo.TextField(
      "",
      "newStagione",
      "col-lg-9 cfg-color-input",
      {
        placeholder: "Nome stagione da aggiungere",

        azioni: [
          {
            label: "+ Aggiungi",
            type: "func",

            func: (
              field,
              bottone,
              campo,
              Oggetto,
              api
            ) => {

              const nome = field.newStagione;

              if (!nome) {
                return;
              }

              AddStagione(
                nome,
                field,
                api
              );

              field.newStagione = "";

            },

            class: "cfg-add-btn-stagioni"
          }
        ]
      }
    )

  ];

}

function LayoutColori(x){

  return [

    CampoAggiuntivo.Html(
      "",
      `
        <div class="cfg-color-header">

          <div class="cfg-column-title big">
            🎨 Colori disponibili
          </div>
        </div>
      `,
      () => true,
      {
        class: 'col-12'
      }
    ),

    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-12",
      {
        type: "ArrayCampiAggiuntivi",
        campiAggiuntivi: [
          ...(x.coloriList || []).map(colore =>
          CampoAggiuntivo.Html(
            "",
            () => `

<div class="cfg-color-card">

  <div
    class="cfg-color-circle"
    style="
      background:${colore.codice || '#ffffff'};
    "
  ></div>

  <div class="cfg-color-name">
    ${colore.check}
  </div>

</div>
`,
            () => true,
            {
              class: "cfg-color-card-wrapper col-lg-2 col-md-3 col-6",
              azioni: [
                {
                  label: "",
                  type: "func",
                  class: "cfg-color-delete-btn",
                  func: (
                    field,
                    bottone,
                    campo,
                    obj,
                    api
                  ) => {

                    const conferma = confirm(
                      `Sei sicuro di voler eliminare il colore "${colore.check}" ?`
                  );

                    if (!conferma) {
                      return;
                    }

                    DeleteColore(
                      colore.id,
                      obj,
                      api
                    );

                  }
                }
              ]
            }
          )

          )

        ]
      }
    ),

    CampoAggiuntivo.InputField(
      "",
      "newColorHex",
      "color",
      "col-auto",
      {
        inputType: "color"
      }
    ),
    CampoAggiuntivo.TextField(
      "",
      "newColorName",
      "col-lg-8 cfg-color-input",
      {
        placeholder: "Nome colore (es. Bordeaux)",

        azioni: [
          {
            label: "+ Aggiungi colore",
            type: "func",

            func: (
              field,
              bottone,
              campo,
              Oggetto,
              api,
              component
            ) => {
console.log("field",field);
              const nome =
                field.newColorName;

              const codice =
                field.newColorHex ||
                field['newColorHex'];

              console.log("COLORE", codice);

              if (!nome || !codice) {
                return;
              }

              AddColore(
                nome,
                codice,
                field,
                api
              );

              field.newColorName = "";
              field.newColorHex = "";

            },

            class: "cfg-add-btn-colori"
          }
        ]
      }
    ),
  ]

}
function LayoutCategorie(x) {

  return [
    /*CampoAggiuntivo.Html(
      "",
      `
    <div class="row g-0">
  `
    ),*/
    CampoAggiuntivo.InputField("", "","ArrayCampiAggiuntivi",'col-lg-3 cfg-column',{ //TODO: Ordinamento Drag & drop
      type: 'ArrayCampiAggiuntivi',
      drop: (event, component, Oggetto)=>{
        console.log(event, component, Oggetto);
        moveItemInArray(Oggetto.categorieTree, event.previousIndex-1,event.currentIndex-1);
        Oggetto.categorieTree.forEach((cat,index)=>{
          cat.ordine = index;
        })
        console.log("rearranged: ", Oggetto.categorieTree)
        var req = Oggetto.categorieTree.map(x=>component.apiPaths.ClassicPost("/prodotti/categorie/update", {...x}))
        forkJoin(req).subscribe(
          d=>{
            refreshLayout(Oggetto);
          }
        )
       // refreshLayout(Oggetto);
      },
      campiAggiuntivi:[
        CampoAggiuntivo.Html("", `
        <div class="cfg-column-title">
            MACRO CATEGORIE
          </div>
        `),
        ...(x.categorieTree || []).map(cat=>CampoAggiuntivo.Html(
          "",
          (ogg)=>{return `
    <div
      class="
        cfg-row-item
        ${x.selectedMacro?.id === cat.id ? 'active' : ''}
      "
    >

      <div class="cfg-row-left">
        <span>
          ${cat.categoria}
        </span>
      </div>
      <span class="cfg-arrow">
        ›
      </span>

    </div>
  `;
          },
          ()=>true,
          {
            class: "cfg-row-wrapper",
            draggable:true,
            onClick: (obj) => {

              obj.selectedMacro = cat;

              obj.selectedMiddle =
                cat?.figli?.[0] || null;

              obj.selectedMicro =
                cat?.figli?.[0]?.figli?.[0] || null;

              refreshLayout(obj);

            },
            azioni: [
              {
                label: "",
                type: "func",
                class: "cfg-delete-btn",

                func: (
                  field,
                  bottone,
                  campo,
                  obj,
                  api,
                  component
                ) => {
                  const conferma = confirm(
                    `Sei sicuro di voler eliminare la categoria "${cat.categoria}" ?`
                  );

                  if (!conferma) {
                    return;
                  }
                  DeleteCategoria(
                    cat.id,
                    obj,
                    api,
                  );

                }
              }
            ]
          })),
        CampoAggiuntivo.TextField(
          "",
          "newMacro",
          "col-12 cfg-add-field",
          {
            placeholder: "es. Donna",

            azioni: [
              {
                label: "+",
                type: "func",

                func: (
                  field,
                  bottone,
                  campo,
                  Oggetto,
                  api,
                  component
                ) => {

                  const nome = field.newMacro;

                  if (!nome) {
                    return;
                  }

                  AddCategoria(
                    nome,
                    null,
                    field,
                    api,

                  );

                  field.newMacro = "";

                },
                class: "cfg-add-btn"
              }
            ]
          }
        )
      ],

    }),
    CampoAggiuntivo.InputField("", "", "ArrayCampiAggiuntivi",'col-lg-3 cfg-column',{
      type: 'ArrayCampiAggiuntivi',
      drop: (event, component, Oggetto)=>{
        console.log(event, component, Oggetto);
        moveItemInArray(Oggetto.selectedMacro.figli, event.previousIndex-1,event.currentIndex-1);
        Oggetto.selectedMacro.figli.forEach((cat,index)=>{
          cat.ordine = index;
        })
        var req = Oggetto.selectedMacro.figli.map(x=>component.apiPaths.ClassicPost("/prodotti/categorie/update", {cat_id: Oggetto.selectedMacro.id,...x}))
        forkJoin(req).subscribe(
          d=>{
            refreshLayout(Oggetto);
          }
        )
        console.log("rearranged: ", Oggetto.selectedMacro.figli)
       // refreshLayout(Oggetto);
      },
      campiAggiuntivi:[

        CampoAggiuntivo.Html(
          "",
          `
    <div class="cfg-middle-header">

      <div class="cfg-column-title">
        ${x.selectedMacro?.categoria || 'SOTTO CATEGORIE'}
      </div>

      <div class="cfg-default-btn">
        ⚙ Taglie default
      </div>

    </div>
  `,
          () => true,
          {

            onClick: (obj) => {

              const modalService =
                obj.component.crudService?.modalService;

              if (!modalService) {
                return;
              }

              const EditModal =
                modalService.open(
                  DynamicEditComponent,
                  {
                    centered: true,
                    backdrop: 'static',
                    container: '#main-wrapper',
                    size: 'lg',
                    windowClass: 'cfg-taglie-modal'
                  }
                );

              (<DynamicEditComponent>EditModal.componentInstance)
                .CrudSettings = PopupTaglie();

              (<DynamicEditComponent>EditModal.componentInstance)
                .Item = {
                categoria: obj.selectedMiddle
              };

            }
          }
        ),
        ...((x.selectedMacro?.figli || []).map(cat =>

          CampoAggiuntivo.Html(
            "",
            (ogg) => {

              return `

            <div
                class="cfg-row-item cfg-row-with-delete
                 ${x.selectedMiddle?.id === cat.id ? 'active' : ''}
                "
            >

              <div class="cfg-row-left">

                <span>
                  ${cat.categoria}
                </span>

              </div>

              <span class="cfg-arrow">
                ›
              </span>

            </div>

          `;

            },
            () => true,
            {
              draggable:true,
              class: "cfg-row-wrapper",
              onClick: (obj) => {

                obj.selectedMiddle = cat;

                obj.selectedMicro =
                  cat?.figli?.[0] || null;

                LoadMicroTaglie(obj);

              },
              azioni: [
                {
                  label: "",
                  type: "func",
                  class: "cfg-delete-btn",

                  func: (
                    field,
                    bottone,
                    campo,
                    obj,
                    api,
                    component
                  ) => {

                    const conferma = confirm(
                      `Sei sicuro di voler eliminare la categoria "${cat.categoria}" ?`
                    );

                    if (!conferma) {
                      return;
                    }

                    DeleteCategoria(
                      cat.id,
                      obj,
                      api,
                    );

                  }
                }
              ]
            }
          )

        )),
        CampoAggiuntivo.TextField(
          "",
          "newMiddle",
          "col-12 cfg-add-field",
          {
            placeholder: "es. Donna",

            azioni: [
              {
                label: "+",
                type: "func",

                func: (
                  field,
                  bottone,
                  campo,
                  Oggetto,
                  api,
                  component
                ) => {

                  const nome = field.newMiddle;

                  if (!nome) {
                    return;
                  }

                  AddCategoria(
                    nome,
                    field.selectedMacro?.id,
                    field,
                    api,

                  );

                  field.newMiddle = "";

                },

                class: "cfg-add-btn"
              }
            ]
          }
        )

      ]
    }),

    /* CampoAggiuntivo.Html(
       "",
       (x) => {

         const middle =
           x.selectedMacro?.figli || [];

         return `

           <div class="cfg-column">

             <div class="cfg-middle-header">

               <div class="cfg-column-title">

                 ${x.selectedMacro?.categoria || ''}

               </div>

               <button class="cfg-default-btn">

                 ⚙ Taglie default

               </button>

             </div>

             ${middle.map(cat => `

               <div
                 class="
                   cfg-row-item
                   ${x.selectedMiddle?.id === cat.id ? 'active' : ''}
                 "
                 onclick="window.selectMiddleCategoria('${cat.id}')"
               >

                 <span>
                   ${cat.categoria}
                 </span>

                 <span class="cfg-arrow">
                   ›
                 </span>

               </div>

             `).join('')}

           </div>

         `;

       },
       () => true,
       {
         class: 'col-lg-4'
       }
     ),
 */
    CampoAggiuntivo.InputField(
      "",
      "",
      "ArrayCampiAggiuntivi",
      "col-lg-6 cfg-column content",
      {
        type: 'ArrayCampiAggiuntivi',

        drop: (event, component, Oggetto) => {
          console.log(event, component, Oggetto);

          if (!Oggetto.selectedMiddle?.figli) {
            return;
          }

          moveItemInArray(
            Oggetto.selectedMiddle.figli,
            event.previousIndex - 1,
            event.currentIndex - 1
          );

          Oggetto.selectedMiddle.figli.forEach((cat, index) => {
            cat.ordine = index;
          });

          const req = Oggetto.selectedMiddle.figli.map(x =>
            component.apiPaths.ClassicPost(
              "/prodotti/categorie/update",
              {
                cat_id: Oggetto.selectedMiddle.id,
                ...x
              }
            )
          );

          forkJoin(req).subscribe(() => {
            LoadMicroTaglie(Oggetto);
          });

          console.log("rearranged micro: ", Oggetto.selectedMiddle.figli);
        },

        campiAggiuntivi: [

          CampoAggiuntivo.Html(
            "",
            (x) => `

          <div class="cfg-column-title big">

            ${x.selectedMiddle?.categoria || ''}

          </div>

        `
          ),
          ...(

            (x.selectedMiddle?.figli || []).length <= 0

              ? [

                CampoAggiuntivo.Html(
                  "",
                  `

            <div class="cfg-empty">

              Nessuna sotto categoria

            </div>

          `
                )

              ]

              : (x.selectedMiddle?.figli || []).map(figlio =>

                CampoAggiuntivo.Html(
                  "",
                  (x) => {

                    const taglieMicro =
                      figlio.taglieList || figlio.taglie || [];

                    return `

      <div class="cfg-micro-card">

    <div class="cfg-micro-left">

      <div class="cfg-card-title">
        ${figlio.categoria}
      </div>

      <div class="cfg-micro-badges">

        ${
                      taglieMicro.length > 0

                        ? `



              ${taglieMicro.sort(
                          (a,b) =>
                            (a.ordine || 0) - (b.ordine || 0)
                        ).map(t => `

                <span class="cfg-taglia-badge">
                  ${t.taglia || t}
                </span>

              `).join('')}

            `

                        : `

              <span class="cfg-empty-small">
                Nessuna taglia
              </span>

            `
                    }

      </div>

    </div>

  </div>

`;
                  },
                  () => true,
                  {
                    class: "cfg-card-wrapper col-12",
                    draggable: true,
                   /* onClick: (obj) => {

                      obj.selectedMicro = figlio;

                      refreshLayout(obj);

                    },*/

                    azioni: [
                      {
                        label: "⚙ Taglie",
                        type: "func",
                        class: "cfg-default-btn",

                        func: (
                          field,
                          bottone,
                          campo,
                          obj,
                          api,
                          component
                        ) => {

                          const modalService =
                            obj.component.crudService?.modalService;

                          if (!modalService) {
                            return;
                          }

                          const EditModal =
                            modalService.open(
                              DynamicEditComponent,
                              {
                                centered: true,
                                backdrop: 'static',
                                container: '#main-wrapper',
                                size: 'lg',
                                windowClass: 'cfg-taglie-modal'
                              }
                            );

                          (<DynamicEditComponent>EditModal.componentInstance)
                            .CrudSettings =
                            PopupTaglieMicro();

                          (<DynamicEditComponent>EditModal.componentInstance)
                            .Item = {
                            micro: figlio,
                            middle: obj.selectedMiddle,
                            parentObj: obj
                          };

                        }
                      },
                      {
                        label: "Elimina",
                        type: "func",
                        class: "cfg-delete-btn",

                        func: (
                          field,
                          bottone,
                          campo,
                          obj,
                          api,
                          component
                        ) => {

                          const conferma = confirm(
                            `Sei sicuro di voler eliminare la micro categoria "${figlio.categoria}" ?`
                          );

                          if (!conferma) {
                            return;
                          }

                          DeleteCategoria(
                            figlio.id,
                            obj,
                            api
                          );

                        }
                      }
                    ]
                  }
                )

              )

          ),
          CampoAggiuntivo.TextField(
            "",
            "newMicro",
            "col-12 cfg-add-field",
            {
              placeholder: "es. Donna",

              azioni: [
                {
                  label: "+",
                  type: "func",

                  func: (
                    field,
                    bottone,
                    campo,
                    Oggetto,
                    api,
                    component
                  ) => {

                    const nome = field.newMicro;

                    if (!nome) {
                      return;
                    }

                    AddCategoria(
                      nome,
                      field.selectedMiddle?.id,
                      field,
                      api,

                    );

                    field.newMicro = "";

                  },
                  class: "cfg-add-btn"
                }
              ]
            }
          )
        ]

      }
    ),
    /*...(x.showTagliePopup
      ? GetPopupTaglie(x)
      : []),
    CampoAggiuntivo.Html(
      "",
      `
    </div>
  `
    ),*/
    /*CampoAggiuntivo.TextField("", "toAdd", 'col-lg-3', {
      azioni:[
        {
          label: "Aggiungi +",
          type: 'func',
          func: (field, bottone, campo, Oggetto, api: ApiPathsService, component: FieldViewerComponent) => {
            {

              if (!field.value) {
                return;
              }

              api.ClassicPost(
                '/prodotti/categorie/add',
                {
                  categoria: field.value,
                }
              ).subscribe((res: any) => {

              })
              }
          },
          class: 'btn'
        }
      ]
    })*/

  ];

}


function ReloadStagioni(
  obj,
  api
) {

  api.ClassicPost(
    '/prodotti/stagioni/list',
    {}
  ).subscribe((res: any) => {

    obj.stagioniList = res.data || [];

    obj.stagioniTable = [...(obj.stagioniList || [])]
      .sort((a, b) => (a.ordine || 0) - (b.ordine || 0))
      .map(stagione => ({
        ...stagione,
        nome: stagione.check || '',
        ordine: stagione.ordine || 0
      }));

    refreshLayout(obj);

  });

}
function AddStagione(
  nome,
  obj,
  api
) {

  api.ClassicPost(
    '/prodotti/stagioni/add',
    {
      check: nome
    }
  ).subscribe(() => {

    ReloadStagioni(
      obj,
      api
    );

  });

}
function DeleteStagione(
  id,
  obj,
  api
) {

  api.ClassicPost(
    '/prodotti/stagioni/delete',
    {
      id: id
    }
  ).subscribe(() => {

    ReloadStagioni(
      obj,
      api
    );

  });

}
function SaveStagioni(
  obj,
  api
) {

  const stagioniAttuali = obj.stagioniList || [];
  const stagioniTable = obj.stagioniTable || [];

  const stagioniDaModificare = stagioniTable.filter(row => {

    const originale = stagioniAttuali.find(
      stagione => stagione.id === row.id
    );

    if (!originale) {
      return false;
    }

    return (
      row.nome !== originale.check ||
      Number(row.ordine) !== Number(originale.ordine || 0)
    );

  });

  if (stagioniDaModificare.length <= 0) {

    api.toastService.success(
      "Stagioni già aggiornate",
      "",
      { toastClass: 'marketplace-success-toast' }
    );

    return;

  }

  forkJoin(
    stagioniDaModificare.map(stagione =>
      api.ClassicPost(
        '/prodotti/stagioni/update',
        {
          id: stagione.id,
          check: stagione.nome,
          ordine: Number(stagione.ordine) || 0
        }
      )
    )
  ).subscribe(() => {

    ReloadStagioni(
      obj,
      api
    );

    api.toastService.success(
      "Stagioni salvate",
      "",
      { toastClass: 'marketplace-success-toast' }
    );

  });

}
function ReloadPopupTaglie(
  obj,
  component,
  callback = null
) {

  component.api.ClassicPost(
    '/prodotti/taglia/list',
    {
      page: 0,
      size: 100,
      cat_id: obj.categoria.id
    }
  ).subscribe((res: any) => {

    obj.taglieList =
      res.data || [];
    obj.taglieTable = (obj.taglieList || [])
      .sort((a, b) => (a.ordine || 0) - (b.ordine || 0))
      .map(taglia => ({
        ...taglia,
        selected: true,
        nome: taglia.taglia || '',
        ordine: taglia.ordine || 0
      }));

    obj.allTaglie =
      obj.taglieList || [];

    (obj.allTaglie || []).forEach(taglia => {

      obj[`taglia_${taglia.id}`] = true;
      obj[`taglia_nome_${taglia.id}`] = taglia.taglia || "";

      obj[`taglia_ordine_${taglia.id}`] = taglia.ordine || 0;

    });
    obj.dynamicTaglieFields = [

      CampoAggiuntivo.Html(
        "",
        `
          <div class="cfg-popup-title">
            ⚙ Taglie default
          </div>
        `,
        () => true,
        {
          class: 'col-12'
        }
      ),
      CampoAggiuntivo.Html(
        "",
        `
    <div class="cfg-popup-info">
      ℹ️ Seleziona l'icona della <b>freccia</b> in corrispondenza della taglia e spostala in alto o in basso per modificare l'ordinamento.
    </div>
  `,
        () => true,
        {
          class: "col-12"
        }
      ),
      CampoAggiuntivo.DraggableTableField(
        "Taglie",
        [
          CampoAggiuntivo.InputField(
            "",
            "selected",
            "checkbox",
            "col-lg-12",
            {
              inputType: "checkbox"
            }
          ),
          CampoAggiuntivo.TextField(
            "Nome",
            "nome",
            "col-lg-12",
            {
              placeholder: "Nome Taglia"
            }
          ),
          // CampoAggiuntivo.TextField(
          //   "Ordine",
          //   "ordine",
          //   "col-lg-3",
          //   {
          //     type: "number",
          //     placeholder: "Ordine"
          //   }
          // )
        ],
        "taglieTable",
        true,
        "col-12",
        (event: CdkDragDrop<string[]>, component, lista) =>{
            moveItemInArray(lista, event.previousIndex, event.currentIndex);
            //Rearrange ordine
            lista.forEach((taglia, index) => {
              taglia.ordine = index + 1;
            })
        }

      ),
      CampoAggiuntivo.TextField(
        "",
        "newTaglia",
        "col-lg-8",
        {
          placeholder:
            "Nuova taglia...",

          azioni: [
            {
              label: "+ Aggiungi",
              type: "func",

              func: (
                field,
                bottone,
                campo,
                Oggetto,
                api,
                componentRef
              ) => {

                const nomeTaglia =
                  (field.newTaglia || '')
                    .trim()
                    .toUpperCase();

                if (!nomeTaglia) {
                  return;
                }

                component.api.ClassicPost(
                  '/prodotti/taglia/add',
                  {
                    taglia: nomeTaglia,
                    fattore: field.categoria.id
                  }
                ).subscribe(() => {

                  field.newTaglia = "";

                  ReloadPopupTaglie(
                    field,
                    component
                  );

                });

              },

              class: "cfg-popup-btn"
            }
          ]
        }
      ),
    ];

    component.Item = {
      ...obj
    };

    if (callback) {
      callback(obj);
    }

  });

}

function BuildPopupMicroFields(
  x,
  component
) {

  const selectedNames =
    (x.microTaglie || []).map(
      t => t.taglia
    );

  const microNames =
    (x.microTaglie || []).map(
      t => t.taglia
    );

  const inheritedMiddleTaglie =
    (x.middleTaglie || []).filter(
      t => !microNames.includes(t.taglia)
    );


  const allTaglie = [

    ...inheritedMiddleTaglie,

    ...(x.microTaglie || [])

  ].sort(
    (a,b) =>
      (a.ordine || 0) -
      (b.ordine || 0)
  );
  allTaglie.sort(
    (a,b) =>
      (a.ordine || 0 ) - (b.ordine || 0)
  );
  x.taglieTable = allTaglie.map(taglia => {
    const isMicro = (x.microTaglie || []).some(
      t => t.taglia === taglia.taglia
    );

    return {
      ...taglia,
      selected: isMicro,
      nome: taglia.taglia || '',
      ordine: taglia.ordine || 0,
      inherited: !isMicro
    };
  });
  x.dynamicFields = [

    CampoAggiuntivo.Html(
      "",
      `
        <div class="cfg-popup-title">
          ⚙ Taglie micro categoria
        </div>
      `,
      () => true,
      {
        class: 'col-12'
      }
    ),
    CampoAggiuntivo.Html(
      "",
      `
    <div class="cfg-popup-info">
      ℹ️ Seleziona l'icona della <b>freccia</b> in corrispondenza della taglia e spostala in alto o in basso per modificare l'ordinamento.
    </div>
  `,
      () => true,
      {
        class: "col-12"
      }
    ),
    CampoAggiuntivo.DraggableTableField(
      "Taglie",
      [
        CampoAggiuntivo.InputField(
          "",
          "selected",
          "checkbox",
          "col-lg-12",
          {
            inputType: "checkbox"
          }
        ),
        CampoAggiuntivo.TextField(
          "Nome",
          "nome",
          "col-lg-12",
          {
            placeholder: "Nome Taglia"
          }
        )
      ],
      "taglieTable",
      true,
      "col-12",
      (event: CdkDragDrop<string[]>, component, lista) =>{
        moveItemInArray(lista, event.previousIndex, event.currentIndex);
        //Rearrange ordine
        lista.forEach((taglia, index) => {
          taglia.ordine = index + 1;
        })
      }
    ),

    CampoAggiuntivo.TextField(
      "",
      "newTagliaMicro",
      "col-lg-12",
      {
        placeholder: "Nuova taglia...",

        azioni: [
          {
            label: "+ Aggiungi",
            type: "func",

            func: (
              field,
              bottone,
              campo,
              Oggetto,
              api,
              componentRef
            ) => {

              const nomeTaglia =
                (field.newTagliaMicro || '')
                  .trim()
                  .toUpperCase();

              if (!nomeTaglia) {
                return;
              }

              component.api.ClassicPost(
                '/prodotti/taglia/add',
                {
                  taglia: nomeTaglia,
                  fattore: field.micro.id
                }
              ).subscribe(() => {

                field.newTagliaMicro = "";

                forkJoin({

                  middleTaglie:
                    component.api.ClassicPost(
                      '/prodotti/taglia/list',
                      {
                        page: 0,
                        size: 100,
                        cat_id: field.middle.id
                      }
                    ),

                  microTaglie:
                    component.api.ClassicPost(
                      '/prodotti/taglia/list',
                      {
                        page: 0,
                        size: 100,
                        cat_id: field.micro.id
                      }
                    )

                }).subscribe((res: any) => {

                  field.middleTaglie =
                    res.middleTaglie?.data || [];

                  field.microTaglie =
                    res.microTaglie?.data || [];

                  BuildPopupMicroFields(
                    field,
                    component
                  );

                  component.Item = {
                    ...field
                  };
                  LoadMicroTaglie(
                    field.parentObj
                  );

                });

              });

            },

            class: "cfg-popup-btn"
          }
        ]
      }
    ),

  ];

  x.allTaglie =
    allTaglie;

}

function PopupTaglie(): OggettoConfig {

  return {

    Id: 'popup_taglie',

    NoSave: true,

    Label: 'Taglie default',

    asyncMap: (
      x,
      component,
      callback
    ) => {

      x.component = component;

      ReloadPopupTaglie(
        x,
        component,
        callback
      );

    },

    campi: [

      CampoAggiuntivo.InputField(
        "",
        "dynamicTaglieFields",
        "",
        "col-12",
        {
          type: 'ArrayCampiAggiuntivi'
        }
      )

    ],

    Azioni: [

      ActionButton.FuncButton(
        "Salva taglie",
        (
          x,
          api,
          onEnd
        ) => {

          const taglieAttuali = x.taglieList || [];
          const taglieTable = x.taglieTable || [];

          const taglieDaEliminare = taglieTable.filter(
            row => !row.selected
          );

          const taglieDaModificare = taglieTable.filter(row => {
            const originale = taglieAttuali.find(t => t.id === row.id);

            if (!originale || !row.selected) {
              return false;
            }

            return (
              row.nome !== originale.taglia ||
              Number(row.ordine) !== Number(originale.ordine || 0)
            );
          });

          if (
            taglieDaEliminare.length <= 0 &&
            taglieDaModificare.length <= 0
          ) {
            api.toastService.success(
              "Taglie salvate",
              "",
              { toastClass: 'marketplace-success-toast' }
            );

            if (onEnd) {
              onEnd();
            }

            return;
          }

          forkJoin([
            ...taglieDaEliminare.map(taglia =>
              api.ClassicPost('/prodotti/taglia/delete', {
                id: taglia.id
              })
            ),

            ...taglieDaModificare.map(taglia =>
              api.ClassicPost('/prodotti/taglia/update', {
                id: taglia.id,
                taglia: taglia.nome,
                ordine: Number(taglia.ordine) || 0
              })
            )
          ]).subscribe(() => {
            api.toastService.success(
              "Taglie salvate",
              "",
              { toastClass: 'marketplace-success-toast' }
            );

            if (onEnd) {
              onEnd();
            }
          });
        },
        {
          class: 'btn btn-success'
        }
      )

    ]

  };

}
function PopupTaglieMicro(): OggettoConfig {

  return {

    Id: "popup_taglie_micro",

    NoSave: true,

    Label: "Taglie micro categoria",

    asyncMap: (
      x,
      component,
      callback
    ) => {

      forkJoin({

        middleTaglie:
          component.api.ClassicPost(
            '/prodotti/taglia/list',
            {
              page: 0,
              size: 100,
              cat_id: x.middle.id
            }
          ),

        microTaglie:
          component.api.ClassicPost(
            '/prodotti/taglia/list',
            {
              page: 0,
              size: 100,
              cat_id: x.micro.id
            }
          )

      }).subscribe((res: any) => {

        x.middleTaglie =
          res.middleTaglie?.data || [];

        x.microTaglie =
          res.microTaglie?.data || [];

        BuildPopupMicroFields(
          x,
          component
        );


        callback(x);

      });

    },

    campi: [

      CampoAggiuntivo.InputField(
        "",
        "dynamicFields",
        "",
        "col-12",
        {
          type: 'ArrayCampiAggiuntivi'
        }
      )

    ],

    Azioni: [

      ActionButton.FuncButton(
        "Salva taglie",
        (
          x,
          api,
          onEnd
        ) => {

          const existingMicroTaglie = x.microTaglie || [];
          const taglieTable = x.taglieTable || [];

          const selectedTaglie = taglieTable.filter(row => row.selected);

          const taglieDaAggiungere = selectedTaglie.filter(row =>
            !existingMicroTaglie.some(t => t.taglia === row.taglia)
          );

          const taglieDaEliminare = existingMicroTaglie.filter(taglia =>
            !taglieTable.some(row => row.selected && row.taglia === taglia.taglia)
          );

          const taglieDaModificare = taglieTable.filter(row => {
            const originale = existingMicroTaglie.find(t => t.id === row.id);

            if (!originale || !row.selected) {
              return false;
            }

            return (
              row.nome !== originale.taglia ||
              Number(row.ordine) !== Number(originale.ordine || 0)
            );
          });

          if (
            taglieDaAggiungere.length <= 0 &&
            taglieDaEliminare.length <= 0 &&
            taglieDaModificare.length <= 0
          ) {
            api.toastService.success(
              "Taglie già aggiornate",
              "",
              { toastClass: 'marketplace-success-toast' }
            );

            if (onEnd) {
              onEnd();
            }

            return;
          }

          forkJoin([
            ...taglieDaAggiungere.map(taglia =>
              api.ClassicPost('/prodotti/taglia/add', {
                taglia: taglia.nome,
                fattore: x.micro.id,
                ordine: Number(taglia.ordine) || 0
              })
            ),

            ...taglieDaEliminare.map(taglia =>
              api.ClassicPost('/prodotti/taglia/delete', {
                id: taglia.id
              })
            ),

            ...taglieDaModificare.map(taglia =>
              api.ClassicPost('/prodotti/taglia/update', {
                id: taglia.id,
                taglia: taglia.nome,
                fattore: x.micro.id,
                ordine: Number(taglia.ordine) || 0
              })
            )
          ]).subscribe(() => {
            LoadMicroTaglie(x.parentObj);

            api.toastService.success(
              "Taglie salvate",
              "",
              { toastClass: 'marketplace-success-toast' }
            );

            if (onEnd) {
              onEnd();
            }
          });
        },
        {
          class: 'btn btn-success'
        }
      )

    ]

  };

}
function refreshLayout(obj) {

  obj.campiMain = [
    ...TopTabs(),
    ...DescriptionField(),
    ...MainLayout(obj)
  ];

}
function LoadMicroTaglie(
  obj,
  callback = null
) {

  const microList =
    obj.selectedMiddle?.figli || [];

  if (microList.length <= 0) {

    refreshLayout(obj);

    if (callback) {
      callback();
    }

    return;
  }

  forkJoin(

    microList.map(micro =>

      obj.component.api.ClassicPost(
        '/prodotti/taglia/list',
        {
          page: 0,
          size: 100,
          cat_id: micro.id
        }
      )

    )

  ).subscribe((responses: any[]) => {

    microList.forEach(
      (
        micro,
        index
      ) => {

        micro.taglieList =
          responses[index]?.data || [];

      }
    );

    refreshLayout(obj);

    if (callback) {
      callback();
    }

  });

}
function ReloadCategorie(
  obj,
  api
) {
  const selectedMacroId =
    obj.selectedMacro?.id;

  const selectedMiddleId =
    obj.selectedMiddle?.id;

  const selectedMicroId =
    obj.selectedMicro?.id;
  api.ClassicPost(
    '/prodotti/categorie/list',
    {}
  ).subscribe((categorie: any[]) => {

    obj.categorieTree = categorie || [];

    obj.selectedMacro =
      obj.categorieTree.find(
        x => x.id === selectedMacroId
      ) || obj.categorieTree?.[0] || null;

    const middleList = obj.selectedMacro?.figli || [];

    obj.selectedMiddle =
      middleList.find(
        x => x.id === selectedMiddleId
      ) || middleList?.[0] || null;

    const microList = obj.selectedMiddle?.figli || [];

    obj.selectedMicro =
      microList.find(
        x => x.id === selectedMicroId
      ) || microList?.[0] || null;

    LoadMicroTaglie(obj);

  });

}
function ReloadColori(
  obj,
  api
) {
  api.ClassicPost(
    '/prodotti/colori/list',
    {}
  ).subscribe((res: any) => {
    obj.coloriList =
      res.data || [];
    refreshLayout(obj);

  });
}

function ReloadBrand(
  obj,
  api
) {
  api.ClassicGet(
    '/prodotti/marca/top',
    {}
  ).subscribe((res: any)=>{
    obj.topBrandList = res.data || res || [];
    refreshLayout(obj);
  });
}

function AddCategoria(
  nome,
  catID,
  obj,
  api
) {

  api.ClassicPost(
    '/prodotti/categorie/add',
    {
      categoria: nome,
      cat_id: catID
    }
  ).subscribe(() => {

    ReloadCategorie(
      obj,
      api
    );

  });

}
function AddColore(
  nome,
  colore,
  obj,
  api
) {

  api.ClassicPost(
    '/prodotti/colori/add',
    {
      check: nome,
      codice: colore
    }
  ).subscribe(() => {

    ReloadColori(
      obj,
      api
    );

    /*obj.newColorName = '';
    obj.newColorHex = '#000000';*/

  });

}
function DeleteColore(
  id,
  obj,
  api
) {

  api.ClassicPost(
    '/prodotti/colori/delete',
    {
      id: id
    }
  ).subscribe(() => {

    ReloadColori(
      obj,
      api
    );

  });
}
function DeleteCategoria(
  id,
  obj,
  api
) {

  api.ClassicPost(
    '/prodotti/categorie/delete',
    {
      id: id,
      figli: true
    }
  ).subscribe(() => {

    ReloadCategorie(
      obj,
      api
    );

  });
  ReloadCategorie(
    obj,
    api
  );

}
function GetCategoriaIcon(nome: string) {

  switch ((nome || '').toLowerCase()) {

    case 'uomo':
      return '🧥';

    case 'donna':
      return '👗';

    case 'bambino':
      return '🧒';

    case 'teen':
      return '🧑';

    default:
      return '📁';

  }

}


export var config_prodottoEnv = () => {

  const crud = config_prodotto();

  return {

    Modules: {
      "config_prodotto": true
    },

    Cruds: [crud],

    Menu: [...crud.MenuItems]

  };

}
